module.exports = __webpack_public_path__ + "static/media/SG_progress_indicator_animated.8ecbcbeb.gif";